var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  function setKitManagedHidden($elements, shouldHide) {
    if (shouldHide) {
      $elements.attr('data-kit-hidden', 'true').addClass('hidden');

      return;
    }

    $elements.each(function () {
      var $element = $(this);

      if ($element.attr('data-kit-hidden') === 'true') {
        $element.removeAttr('data-kit-hidden').removeClass('hidden');
      }
    });
  }

  function getStarterKitInventorySku($product) {
    var inventorySkuBaseId = $product.find('.js-inv-status-list').data('sku-base-id');

    return inventorySkuBaseId ? String(inventorySkuBaseId) : '';
  }

  function isStarterKitUnavailable($product) {
    var inventorySkuBaseId = getStarterKitInventorySku($product);
    var inventorySku = inventorySkuBaseId ? prodcat.data.getSku(inventorySkuBaseId) : null;

    return Boolean(inventorySku && inventorySku.INVENTORY_STATUS !== 1);
  }

  function hasStarterKitCompleteSelection($product) {
    var $starterItemsShaded = $product.find(
      '.js-product-starter-item:not(.js-product-starter-non-shaded-item)'
    );
    var selectedCount = 0;

    $starterItemsShaded.each(function () {
      if ($(this).find('.js-product-starter-shades-grid-item.active').first().length) {
        selectedCount += 1;
      }
    });

    return $starterItemsShaded.length > 0 && selectedCount === $starterItemsShaded.length;
  }

  // Returns true if the user has selected at least one shade (partial or complete).
  function hasAnyStarterKitSelection($product) {
    return $product
      .find('.js-product-starter-item:not(.js-product-starter-non-shaded-item)')
      .filter(function () {
        return $(this).find('.js-product-starter-shades-grid-item.active').first().length > 0;
      })
      .length > 0;
  }

  function syncStarterKitAvailability($product) {
    var isUnavailable = isStarterKitUnavailable($product);
    var $addBtn = $('.js-kit-add-to-cart', $product);
    var $buyNowBtn = $('.js-buy-now-btn');
    var $shadeGridItems = $('.js-product-starter-shades-grid-item', $product);

    // Mark individual shades as non-interactive when the kit is OOS.
    // Accordion toggles remain clickable so the user can still view shades.
    $shadeGridItems.attr('aria-disabled', isUnavailable);

    if (isUnavailable) {
      // Clear any active shade selection — OOS kit cannot have a selection.
      $shadeGridItems.removeClass('active hovered secondactive');
      // Disable the CTA but keep it visible (grayed) to convey the OOS state.
      $addBtn.addClass('button--disabled').data('disabled', true).removeData('kit-skus');
      $buyNowBtn.addClass('button--disabled').data('disabled', true).removeData('kit-skus');
      // Un-hide if it was previously hidden by kit-managed logic so it stays visible.
      setKitManagedHidden($addBtn.add($buyNowBtn), false);
    }

    // OOS-specific notify/preorder CTA must never be shown unless a notify workflow is active.
    $('.soldout-preorder', $product).hide();

    return isUnavailable;
  }

  function updateStarterKitCtaState($product, isDisabled) {
    var $addBtn = $('.js-kit-add-to-cart', $product);
    var $buyNowBtn = $('.js-buy-now-btn');
    var hasCompleteSelection = hasStarterKitCompleteSelection($product);

    if (syncStarterKitAvailability($product)) {
      return;
    }

    if (!hasCompleteSelection) {
      // Only hide the CTA when the user has actively started a selection but not
      // finished it. If no selection has been made yet (zero shades chosen), keep
      // the CTA visible in whatever state the server rendered for visibility.
      // This branch still disables the CTA until the selection is complete,
      // which preserves the grayed-but-visible OOS presentation without relying
      // on inventory data timing. For OOS kits the user can never select shades,
      // so this branch will never hide their CTA.
      if (hasAnyStarterKitSelection($product)) {
        setKitManagedHidden($addBtn.add($buyNowBtn), true);
      }
      $addBtn.addClass('button--disabled').data('disabled', true).removeData('kit-skus');
      $buyNowBtn.addClass('button--disabled').data('disabled', true).removeData('kit-skus');
      $('.soldout-preorder', $product).hide();

      return;
    }

    setKitManagedHidden($addBtn.add($buyNowBtn), false);
    $addBtn.show().toggleClass('button--disabled', isDisabled).data('disabled', isDisabled);
    $('.soldout-preorder', $product).hide();
  }

  function getStarterKitShadeImage(skuData) {
    if (!skuData || !skuData.IMAGE_MEDIUM_COMBINED || !skuData.IMAGE_MEDIUM_COMBINED[1]) {
      return '';
    }

    return skuData.IMAGE_MEDIUM_COMBINED[1];
  }

  function updateStarterKitSectionImage($productImageKit, $shadeThumbKit, skuData) {
    var shadeImage = getStarterKitShadeImage(skuData);

    if (!shadeImage) {
      // If no shade-specific thumb exists, keep the default product image visible.
      $shadeThumbKit.addClass('hidden').removeAttr('data-src').attr('src', '');
      $productImageKit.removeClass('hidden');

      return;
    }

    $shadeThumbKit.removeClass('hidden');
    $shadeThumbKit.attr('data-src', shadeImage);
    $shadeThumbKit.attr('src', shadeImage);
    $productImageKit.addClass('hidden');
  }

  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, hasDramming) {
    // don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }
    if (typeof skuBaseId === 'undefined') {
      skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
    }
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-starter-shades-v2 .js-product-starter-shades-grid');
    var $selectedShade = $shadesGrid.find(
      '.js-product-starter-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
    );
    var $productImageKit = $product.find('.js-product-starter-items-section-image');
    var $shadeThumbKit = $product.find('.js-product-starter-items-section-smoosh');
    var skuData = prodcat.data.getSku(skuBaseId);

    if ($shadesGrid.length < 1) {
      return null;
    }

    if (isStarterKitUnavailable($product)) {
      return null;
    }

    $product.attr('data-sku-base-id', skuBaseId);
    var $shadeGridItem = $('.js-product-starter-shades-grid-item', $product);

    if (hasDramming) {
      $('.js-product-starter-shades-grid-item.secondactive', $product).removeClass(
        'active secondactive'
      );
      $selectedShade.addClass('active secondactive');
    } else {
      $shadeGridItem.not('.secondactive').removeClass('active');
      updateStarterKitSectionImage($productImageKit, $shadeThumbKit, skuData);
      $selectedShade.addClass('active');
    }
  });

  $(document).on(
    'product.skuSelectKit',
    '.js-starter-kit-v2',
    function (e, skuBaseId, hasDramming, $shadesGrid) {
      if (typeof skuBaseId === 'undefined') {
        skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
      }
      var $product = $(this);
      var $starterItemsShaded = $(
        '.js-product-starter-item:not(.js-product-starter-non-shaded-item)',
        $product
      );
      var $starterItem = $shadesGrid.closest('.js-product-starter-item');
      var $productImageKit = $starterItem.find('.js-product-starter-items-section-image');
      var $shadeThumbKit = $starterItem.find('.js-product-starter-items-section-smoosh');
      var skuData = prodcat.data.getSku(skuBaseId);
      var $selectedShade = $shadesGrid.find(
        '.js-product-starter-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
      );
      var $shadeGridItem = $('.js-product-starter-shades-grid-item', $shadesGrid);
      var $addBtn = $('.js-kit-add-to-cart', $product);
      var selected_skus = [];
      var skus_string = [];
      var skusNoShoppable = [];

      if ($shadesGrid.length < 1) {
        return null;
      }
      $product.attr('data-sku-base-id', skuBaseId);
      if (hasDramming) {
        $('.js-product-starter-shades-grid-item.secondactive', $product).removeClass(
          'active secondactive'
        );
        $selectedShade.addClass('active secondactive');
      } else {
        $shadeGridItem.not('.secondactive').removeClass('active');
        updateStarterKitSectionImage($productImageKit, $shadeThumbKit, skuData);
        $selectedShade.addClass('active');
      }

      updateStarterKitCtaState($product, true);

      $starterItemsShaded.each(function () {
        var $item = $(this);
        var $selectedShade = $item.find('.js-product-starter-shades-grid-item.active').first();

        if ($selectedShade.length) {
          var skuBaseId = $selectedShade.data('sku-base-id');

          selected_skus.push(skuBaseId);
        }
      });

      if (selected_skus.length === $starterItemsShaded.length) {
        skusNoShoppable = $.grep(selected_skus, function (skuId) {
          var skuDataL2 = prodcat.data.getSku(skuId);

          return skuDataL2.INVENTORY_STATUS !== 1;
        });

        if (skusNoShoppable.length <= 0) {
          updateStarterKitCtaState($product, false);
          $('.js-buy-now-btn').removeClass('button--disabled').data('disabled', false);
        } else {
          updateStarterKitCtaState($product, true);
          $('.js-buy-now-btn').addClass('button--disabled').data('disabled', true);
        }
      }

      skus_string = selected_skus.join(',');

      $addBtn.data('kit-skus', skus_string);
      $('.js-buy-now-btn').data('kit-skus', skus_string);
    }
  );

  $(document).on('inv_status_display:updated', '.js-product', function () {
    var $product = $(this);
    var $shadeGrid = $product.find('.js-product-starter-shades-v2 .js-product-starter-shades-grid');
    var $items = $shadeGrid.find('.js-product-starter-shades-grid-item');
    $items.each(function () {
      var $this = $(this);
      var enableReorder = $this.closest($shadeGrid).find($items).length > 1;
      var skuBaseId = $this.data('sku-base-id');
      var currentInvStatus = $this.data('inventoryStatus');
      var skuDataL2 = prodcat.data.getSku(skuBaseId);
      var invStatus;

      if (!skuDataL2) {
        if (currentInvStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }

        return;
      }

      invStatus = skuDataL2.INVENTORY_STATUS;
      if (currentInvStatus === invStatus && invStatus !== 1 && enableReorder) {
        $this.closest($shadeGrid).append($this);
      }
      // Update Shade Inventory Status
      if (parseInt(currentInvStatus) !== parseInt(invStatus)) {
        $this.removeClass('shade-inv-status--' + currentInvStatus);
        $this.addClass('shade-inv-status--' + invStatus);
        $this.attr('data-inventory-status', invStatus).data('inventoryStatus', invStatus);
        if (invStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }
      }
    });

  });

  Drupal.behaviors.productStarterItemsV2 = {
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.$addBtn = $('.js-add-to-cart', '.js-product-dramming');
      if ($('.js-second-shade-select-option').length) {
        self.drammingPage = true;
        self.$addBtn.addClass('button--disabled');
        self.$addBtn.data('disabled', true);
      }

      var $templates = $('.js-product-starter-shades-v2', context);

      $templates.each(function () {
        var $template = $(this);
        var $starterKit = $template.closest('.js-starter-kit-v2');
        var $product = $template.closest('.js-product');

        // The soldout/preorder CTA must never appear on starter kit pages unless
        // a notify workflow is explicitly active — hide it unconditionally.
        $('.soldout-preorder', $product).hide();

        if ($starterKit.length) {
          updateStarterKitCtaState(
            $starterKit,
            $('.js-kit-add-to-cart', $starterKit).hasClass('button--disabled')
          );
        }

        self.setEvents($template);
      });

      $(document).on('product:quickshopV2', function () {
        var $template;

        $template = $('.js-product-starter-shades-v2', $(this));
        self.setEvents($template);
      });
    },

    resetGrid: function ($template) {
      var $product = $template.closest('.js-product');
      var $filterArrow = $product.find('.js-filter-arrow', $product);
      var $sectionDetail =  $product.find('.js-product-starter-shades__detail', $product);
      var $sectionGrid =  $product.find('.js-product-starter-shades', $product);
      $filterArrow.removeClass('rotated');
      $sectionDetail.removeClass('hidden');
      $sectionGrid.addClass('hidden');
    },

    setEvents: function ($template) {
      var self = this;
      var $product = $template.closest('.js-product');
      var $shadesGrid = $('.js-product-starter-shades-grid', $product);
      var $shadesGridItem = $('.js-product-starter-shades-grid-item', $product);
      var $shadesTabs = $('.js-product-full-shade--filter', $product);
      var $selectedShade = $('.js-selected-shade', $product);
      var $hoveredShade = $('.js-hovered-shade', $product);
      var $gridShowWrapper = $('.js-filter-info-wrapper', $product);
      var $filterArrow = $('.js-filter-arrow', $product);
      var $sectionDetail = $('.js-product-starter-shades__detail', $product);
      var $sectionGrid = $('.js-product-starter-shades', $product);
      var $starterItem = $('.js-product-starter-item', $product);
      var $gridToggle = $('.js-toggle-grid', $product);
      var $gridShowGrid = $('.js-show-grid', $product);
      var $gridHideGrid = $('.js-hide-grid', $product);
      var $gridToggleName = $('.js-starter-product', $product);

      $shadesGridItem.once().on('click', function (event) {
        event.preventDefault();
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');
        var $shadesGridParent = $this.closest($shadesGrid);
        var skuData = prodcat.data.getSku(skuBaseId);
        var $detailHex = $this.closest($starterItem).find('.js-sku-hex');
        var $detailInventory = $this.closest($starterItem).find('.js-product-starter-shades__detail');
        let noInventory = [2, 4, 7];

        if (isStarterKitUnavailable($product)) {
          return;
        }

        // Restrict the second click on the same shade
        if ($this.hasClass('active')) {
          self.resetGrid($template);
          return;
        }
        $product.trigger('product.skuSelectKit', [skuBaseId, self.toggleShade, $shadesGridParent]);
        var selectedShadeHex = skuData.HEX_VALUE_STRING;
        var selectedShadeInventory = skuData.INVENTORY_STATUS;

        $detailHex.css('background-color', selectedShadeHex);
        $detailInventory.attr('data-inventory-status', selectedShadeInventory);
        if (noInventory.indexOf(selectedShadeInventory) !== -1) {
          $detailInventory.addClass('out-of-stock');
         } else {
          $detailInventory.removeClass('out-of-stock');
         }
        self.resetGrid($template);
        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $shadesGridItem.on('mouseover', function () {
        var $this = $(this);
        var $thisGrid = $this.closest($starterItem).find($sectionGrid);
        var skuBaseId = $this.data('sku-base-id');
        var skuData = prodcat.data.getSku(skuBaseId);
        var $shadeName = $thisGrid.find('.js-sku-shade-hover-name');
        var $shadeDesc = $thisGrid.find('.js-sku-shade-hover-description');

        if (isStarterKitUnavailable($product)) {
          return;
        }

        // Restrict the second click on the same shade
        if ($this.hasClass('hovered')) {
          return;
        }
        $shadesGridItem.removeClass('hovered');
        $this.addClass('hovered');
        $shadeName.html(skuData['SHADENAME']);
        $shadeDesc.html(skuData['SHADE_DESCRIPTION']);
        $hoveredShade.removeClass('hidden');
        $selectedShade.addClass('hidden');
        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $shadesGridItem.on('mouseleave', function () {
        var $this = $(this);

        $shadesGridItem.removeClass('hovered');
        $hoveredShade.addClass('hidden');
        $selectedShade.removeClass('hidden');
      });

      $gridToggle.once().on('click', function () {
        var $this = $(this);
        var $thisItem = $this.closest($starterItem);

        // No OOS guard here: accordions must open so the user can see shades
        // (shades are non-clickable via aria-disabled and the shade-item handler).
        if ($this.find($filterArrow).hasClass('rotated')) {
          $this.find($filterArrow).removeClass('rotated');
          $thisItem.find($sectionDetail).removeClass('hidden');
          $thisItem.find($sectionGrid).addClass('hidden');
        } else {
          self.resetGrid($template);
          $thisItem.find($sectionDetail).addClass('hidden');
          $thisItem.find($sectionGrid).removeClass('hidden');
          $this.find($filterArrow).addClass('rotated');
          // Do NOT update CTA state here — opening a shade grid is a UI action only.
          // CTA is managed by shade selection (product.skuSelectKit) and page init.
        }
      });

      $gridToggleName.once().on('click', function () {
        var $this = $(this);
        var $thisItem = $this.closest($starterItem);

        if ($thisItem.find($filterArrow).hasClass('rotated')) {
          self.resetGrid($template);
        } else {
          self.resetGrid($template);
          $thisItem.find($sectionDetail).addClass('hidden');
          $thisItem.find($sectionGrid).removeClass('hidden');
          $thisItem.find($filterArrow).addClass('rotated');
          // Do NOT update CTA state here — opening a shade grid is a UI action only.
        }
      });

      $gridShowGrid.once().on('click', function () {
        var $this = $(this);

        self.resetGrid($template);
        $this.parent().addClass('hidden');
        $this.closest($starterItem).find($sectionGrid).removeClass('hidden');
        $this.closest($starterItem).find($filterArrow).addClass('rotated');
        // Do NOT update CTA state here — opening a shade grid is a UI action only.
      });

      $gridHideGrid.once().on('click', function () {
        self.resetGrid($template);
      });
      // @todo check ADA - we are not using href for shade
      $shadesGridItem.once().on('keydown', function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });

      $('.js-product-full-shade--filter')
        .once()
        .on('click tab', function (event) {
          event.preventDefault();
          var $tab = $(this);
          var colorFamily = $tab.data('filter');

          $product.trigger('product.showColorFamily', [colorFamily]);
        });

      $(document).on('product.showColorFamily', '.js-product', function (e, colorFamily) {
        var defaultFamily = 'all';
        var selectedColorFamily;
        var $selectedShade = $shadesGrid
          .find('.js-product-starter-shades-grid-item.active')
          .first();
        var skuBaseId = $selectedShade.data('sku-base-id');

        $shadesTabs.removeClass('active');
        $shadesTabs.each(function () {
          selectedColorFamily = $(this).data('filter');
          if (
            typeof selectedColorFamily !== typeof undefined &&
            selectedColorFamily === colorFamily
          ) {
            $(this).addClass('active');
          }
        });
        $shadesGridItem.removeClass('hidden');

        if (colorFamily !== defaultFamily) {
          $shadesGridItem.each(function () {
            var $shade = $(this);
            var shadeFamily = $shade.data('shade-family');

            if (!!shadeFamily) {
              shadeFamily = shadeFamily.replace(/\s+/g, '').toLowerCase().split(',');
              if (shadeFamily.indexOf(colorFamily.toLowerCase()) === -1) {
                $shade.addClass('hidden');
              }
            }
          });
        }
        self.loadSelectedShade(skuBaseId, colorFamily, $product, $shadesTabs);
      });

      $(document).trigger('product.colorFamilyLoaded');
    },

    loadSelectedShade: function (skuBaseId, colorFamily, $product, $shadesTabs) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var shadeName = _.result(skuData, 'SHADENAME');
      var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);

      if (skuBaseId && $product.hasClass('js-product-full-v2')) {
        history.replaceState({}, shadeName, shadeRouteName);

        return;
      }

      if (colorFamily !== $shadesTabs.first().text()) {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#/family/' + colorFamily);
        }
      } else {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#');
        }
      }

      return;
    },
    attached: false
  };
})(jQuery);
